<template>
	<div class="addzz">
		<el-dialog 
			:modal-append-to-body='true'
			width="680px"
			center
			:append-to-body='true'
			@close="closeXz"
			:visible.sync="editXz">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					{{title}}
					<div class="addline"></div>
				</div>
			</div>
			<div class="formWraps">
				<el-form ref="form" :model="formData" :rules="rules" class="formWrap" label-position="right" label-width="100">
					<el-form-item label="类别" class="form_item" prop="type">
						<el-input placeholder="请输入类别" v-model="formData.class_name" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="分值" class="form_item" prop="score">
						<el-input-number v-model="formData.score" :min="5"></el-input-number>
					</el-form-item>
					<el-form-item label="评分标准" class="form_item" prop="content">
						<el-input type="textarea" v-model="formData.describe" :rows="10"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="closeXz()">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dwgl } from '@/axios'
	let that;
	export default{
		data() {
			return{
				title:'添加项目',
				formData:{
					uid:this.$store.state.user.userinfo.id,
					class_id:"",
					class_name:"",
					score:5,
					describe:"",
					type:1,//1:自定义2：默认
				},
				type:'add',
				editXz:false,
				rules:{
					type:[{ required: true, message: '请输入类别', trigger: 'blur' }],
					score:[{ required: true, message: '请输入分值', trigger: 'blur' }],
				},
			}
		},
		created(){that = this;},
		methods:{
			// 新增条目弹窗
			openXz(type){
				that.type = type
				that.editXz = true;
			},
			// 关闭弹窗
			closeXz(){
				that.editXz = false;
				that.formData = {
					uid:this.$store.state.user.userinfo.id,
					class_id:"",
					class_name:"",
					score:5,
					describe:"",
					type:1
				}
			},
			// 提交
			submit(){
				if(that.type == 'add'){
					dwgl.addStarRole(that.formData).then(res => {
						if(res.code == 200){
							that.closeXz()
							that.$emit('typeList')
						}else{
							Message.error(res.msg)
						}
					})
				}else{
					dwgl.updateStarRole(that.formData).then(res => {
						if(res.code == 200){
							that.closeXz()
							that.$emit('typeList')
						}else{
							Message.error(res.msg)
						}
					})
				}
			},
			// 编辑条目
			editxzs(data){
				that.formData = {
					uid:this.$store.state.user.userinfo.id,
					id:data.id,
					class_name:data.class_name,
					score:data.score,
					describe:data.describe,
					type:data.type
				}
				that.openXz('edit');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.formWraps{
		display: flex;
		justify-content: center;
		.formWrap{
			width: 500px;
		}
	}
</style>
